import {useRef} from "react";

export const useComparisonTableRefs = () => {
    const headerRef = useRef<HTMLDivElement>(null);
    const tableRef = useRef<HTMLDivElement>(null);
    const tableRowsRef = useRef<HTMLDivElement>(null);

    return {
        headerRef,
        tableRef,
        tableRowsRef
    };
};
import {useRef} from "react";

export const useComparisonTableRefs = () => {
    const headerRef = useRef<HTMLDivElement>(null);
    const tableRef = useRef<HTMLDivElement>(null);
    const tableRowsRef = useRef<HTMLDivElement>(null);

    return {
        headerRef,
        tableRef,
        tableRowsRef
    };
};
